import { useFieldById } from '/@/hooks/fields';
import FieldDashboard from './dashboard';

const FieldMonitoring = ({ fieldId }: { fieldId: number }) => {
    const fieldQuery = useFieldById({ id: fieldId });
    return <FieldDashboard cropMonitoringId={fieldQuery.data?.activeCropMonitoring?.id} fieldId={fieldId} />;
};

export default FieldMonitoring;
